import request from '@/utils/request'

// ================== 开发者资质 ==================

// 我的开发者资质（含审核状态与驳回原因）
export function getDeveloperInfo () {
  return request({
    url: '/codeStoreFrontAdmin/developerInfo',
    method: 'get'
  })
}

// 提交开发者申请（含实名认证）
export function applyDeveloper (data) {
  return request({
    url: '/codeStoreFrontAdmin/developerApply',
    method: 'post',
    data: data
  })
}

// ================== 我的插件 ==================

// 我上传的插件列表
export function listMyPlugins (params) {
  return request({
    url: '/codeStoreFrontAdmin/myPlugins',
    method: 'get',
    params: params
  })
}

// 插件详情（编辑回显，含版本列表与分类）
export function getMyPluginDetail (pluginId) {
  return request({
    url: '/codeStoreFrontAdmin/myPluginDetail',
    method: 'get',
    params: { pluginId: pluginId }
  })
}

// 新增 / 编辑插件
export function savePlugin (data) {
  return request({
    url: '/codeStoreFrontAdmin/pluginSave',
    method: 'post',
    data: data
  })
}

// 提交插件审核
export function submitPluginAudit (pluginId) {
  return request({
    url: '/codeStoreFrontAdmin/pluginSubmit',
    method: 'post',
    data: { pluginId: pluginId }
  })
}

// 插件上下架（soldOut: 1-下架 0-上架）
export function changePluginSoldOut (pluginId, soldOut) {
  return request({
    url: '/codeStoreFrontAdmin/pluginSoldOut',
    method: 'post',
    data: { pluginId: pluginId, soldOut: soldOut }
  })
}

// 删除插件
export function deleteMyPlugin (pluginId) {
  return request({
    url: '/codeStoreFrontAdmin/pluginDelete',
    method: 'delete',
    params: { pluginId: pluginId }
  })
}

// ================== 版本管理 ==================

// 版本列表
export function listPluginVersions (pluginId) {
  return request({
    url: '/codeStoreFrontAdmin/pluginVersions',
    method: 'get',
    params: { pluginId: pluginId }
  })
}

// 新增版本
export function addPluginVersion (data) {
  return request({
    url: '/codeStoreFrontAdmin/pluginVersionAdd',
    method: 'post',
    data: data
  })
}

// 编辑版本（infoCodeData 为空表示不替换代码包）
export function editPluginVersion (data) {
  return request({
    url: '/codeStoreFrontAdmin/pluginVersionEdit',
    method: 'put',
    data: data
  })
}

// 删除版本
export function deletePluginVersion (infoId) {
  return request({
    url: '/codeStoreFrontAdmin/pluginVersionDelete',
    method: 'delete',
    params: { infoId: infoId }
  })
}

// 编辑器内图片上传（复用开发者素材上传接口）
export function uploadEditorImage (formData) {
  return request({
    url: '/codeStoreFrontAdmin/developerUploadCert',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 插件分类
export function getPluginCate () {
  return request({
    url: '/codeStoreFrontAdmin/developerPluginCate',
    method: 'get'
  })
}

// ================== 订单与收益 ==================

// 我的插件订单
export function listMyOrders (params) {
  return request({
    url: '/codeStoreFrontAdmin/myOrders',
    method: 'get',
    params: params
  })
}

// 收益账户概览
export function getMyIncome () {
  return request({
    url: '/codeStoreFrontAdmin/myIncome',
    method: 'get'
  })
}

// 收益流水
export function listMyIncomeLogs (params) {
  return request({
    url: '/codeStoreFrontAdmin/myIncomeLogs',
    method: 'get',
    params: params
  })
}

// ================== 收款账户 ==================

export function listBankAccounts () {
  return request({
    url: '/codeStoreFrontAdmin/bankList',
    method: 'get'
  })
}

export function addBankAccount (data) {
  return request({
    url: '/codeStoreFrontAdmin/bankAdd',
    method: 'post',
    data: data
  })
}

export function editBankAccount (data) {
  return request({
    url: '/codeStoreFrontAdmin/bankEdit',
    method: 'put',
    data: data
  })
}

export function setDefaultBank (id) {
  return request({
    url: '/codeStoreFrontAdmin/bankDefault',
    method: 'post',
    data: { id: id }
  })
}

export function deleteBankAccount (id) {
  return request({
    url: '/codeStoreFrontAdmin/bankDelete',
    method: 'delete',
    params: { id: id }
  })
}

// ================== 提现 ==================

// 提现规则与可提现余额
export function getWithdrawConfig () {
  return request({
    url: '/codeStoreFrontAdmin/withdrawConfig',
    method: 'get'
  })
}

// 提交提现申请
export function applyWithdraw (data) {
  return request({
    url: '/codeStoreFrontAdmin/withdrawApply',
    method: 'post',
    data: data
  })
}

// 提现记录
export function listWithdraws (params) {
  return request({
    url: '/codeStoreFrontAdmin/withdrawList',
    method: 'get',
    params: params
  })
}

// 撤销提现申请
export function cancelWithdraw (id) {
  return request({
    url: '/codeStoreFrontAdmin/withdrawCancel',
    method: 'post',
    data: { id: id }
  })
}

// 可提现收益转入消费余额（单向，不可逆；amount 单位：分）
export function transferIncomeToBalance (data) {
  return request({
    url: '/codeStoreFrontAdmin/incomeToBalance',
    method: 'post',
    data: data
  })
}
